import UlFormBtn from './btn.vue';
import UlFormCheck from './check.vue';
import UlFormDate from './date.vue';
import UlFormDatePicker from './date-picker.vue';
import UlFormEditor from './editor.vue';
import UlFormGender from './gender.vue';
import UlFormInput from './input.vue';
import UlFormMask from './mask.vue';
import UlFormNumber from './number.vue';
import UlFormPassword from './password.vue';
import UlFormPhone from './phone.vue';
import UlFormPrice from './price.vue';
import UlFormRadio from './radio.vue';
import UlFormSelect from './select.vue';
import UlFormTouristFio from './touristFio.vue';

export default {
  install(Vue) {
    Vue.component('UlFormBtn', UlFormBtn);
    Vue.component('UlFormCheck', UlFormCheck);
    Vue.component('UlFormDate', UlFormDate);
    Vue.component('UlFormDatePicker', UlFormDatePicker);
    Vue.component('UlFormEditor', UlFormEditor);
    Vue.component('UlFormGender', UlFormGender);
    Vue.component('UlFormInput', UlFormInput);
    Vue.component('UlFormMask', UlFormMask);
    Vue.component('UlFormNumber', UlFormNumber);
    Vue.component('UlFormPassword', UlFormPassword);
    Vue.component('UlFormPhone', UlFormPhone);
    Vue.component('UlFormPrice', UlFormPrice);
    Vue.component('UlFormRadio', UlFormRadio);
    Vue.component('UlFormSelect', UlFormSelect);
    Vue.component('UlFormTouristFio', UlFormTouristFio);
  },
};
